import { Box, Button, CircularProgress, Typography } from "@mui/material";
import React, { Suspense, useState, useRef, useEffect } from "react";
import { useProfileData } from "../../hooks/useProfileData";
import StripeCheckoutForm from '../StripeCheckoutForm';
import { getPrices } from "../../utils/api";
import VerifiedIcon from '@mui/icons-material/Verified';
import TrialButton from "./trialButton";
import { wrapPromise } from "../../utils/helper";
import { useTheme } from '@mui/material/styles';

const enableMonetization = process.env.REACT_APP_ENABLE_MONETIZATION === 'true';

interface PremiumPurchaseButtonProps {
  requiredPremiumKey: string;
  redirectURL?: string;
  sampleData?: any;
}

const PremiumPurchaseButtonProfilePage: React.FC<PremiumPurchaseButtonProps> = (props) => {
  const { requiredPremiumKey, redirectURL = "", sampleData = null } = props;
  const { creatorProfileData } = useProfileData();

  // const dataPromise = useRef(null);
  const loadedData = useRef(sampleData);
  const isLoading = useRef<boolean>(false);
  const [ isStripeOpen, setIsStripeOpen ] = useState<boolean>(false);
  const [ stripeItem, setStripeItem ] = useState<string>(null);
  const [ trialPeriod, setTrialPeriod ] = useState<number>(0);
  const [ dataPromise, setDataPromise ] = useState(null);
  const [ , setRefresh ] = useState<boolean>(false);
  const theme = useTheme();

  useEffect(() => {
    if (sampleData){
      loadedData.current = sampleData;
      setRefresh((r: boolean) => !r)
    } else {
      setDataPromise(wrapPromise(loadData()))
    }
  }, [sampleData]) //eslint-disable-line react-hooks/exhaustive-deps

  const handlePremiumPurchase = () => {
    // disable buttons if just showing test data
    if (!sampleData) {
      setStripeItem(requiredPremiumKey)
      setIsStripeOpen(true)
    }
  };

  const loadData = () => {
    if (!isLoading.current && !loadedData.current) {
      isLoading.current = true;
      if (requiredPremiumKey) {
        let promise = getPrices([requiredPremiumKey])
                      .then(res => res.json())
                      .then(data => {
                        if (data) {
                          loadedData.current = data[requiredPremiumKey];
                        }
                      })
                      .catch(err => {
                        console.log(err)
                        loadedData.current = null;
                      })
                      .finally(() => {
                        isLoading.current = false;
                      })

        return promise;
      } else {
        isLoading.current = false;
        return Promise.resolve();
      }
    } else {
      return Promise.resolve();
    }
  }

  const Loading = () => {
    return (
      <Box>
        <Button
          id={`button-premium-purchase`}
          variant="outlined"
          size={"large"}
          disabled
          sx={{
            whiteSpace: 'nowrap',
          }}
        >
          {`Subscribe`}
        </Button>
      </Box>
    )
  }

  const RealButton = () => {
    if (!loadedData.current) {
      if (dataPromise) {
        dataPromise.read()
      }
    }

    let priceStr = ""
    if (loadedData.current) {
      let data = loadedData.current;
      if (data.currency === 'usd') priceStr += "$"
      priceStr += data.unit_amount/100
      if (data.type === 'recurring') priceStr += `/${data.recurring.interval}`
    }

    return (
      <Box>
        <Button
          id={`button-premium-purchase`}
          variant="outlined"
          size={"large"}
          onClick={handlePremiumPurchase}
          sx={{
            whiteSpace: 'nowrap',
          }}
        >
          {`Subscribe for ${priceStr}`}
        </Button>
        <StripeCheckoutForm item={stripeItem} isOpen={isStripeOpen} setIsOpen={setIsStripeOpen} redirectURL={redirectURL || ""} isPremium={true} trialPeriod={trialPeriod}/>
      </Box>
    )
  }

  if (!enableMonetization) return <></>

  return (
    <Suspense fallback={<Loading />}>
      <RealButton />
    </Suspense>
  )
}

export default PremiumPurchaseButtonProfilePage
